import { useScroll, useWindowSize } from '@vueuse/core';

export function useDayScrollHandler<T>(items: Ref<T[]>, active: Ref<T>, onLoad: () => void) {
  const scrollContainer = ref<HTMLElement>();
  const els = ref<HTMLElement[]>();

  const { width } = useWindowSize();

  const isMobile = computed(() => width.value < 800);

  const { y: desktopY } = useScroll(scrollContainer, { behavior: 'smooth' });
  const { y: mobileY } = useScroll(window, { behavior: 'smooth' });

  function handleScrollY(y: number) {
    if (!els.value) return;
    const nextIndex = els.value.sort((a, b) => a.$el.offsetTop - b.$el.offsetTop).findIndex(s => y < s.$el.offsetTop);
    const index = nextIndex !== -1 ? Math.max(nextIndex - 1, 0) : (els.value.length - 1);

    if (items.value.length - index < 8) onLoad();
    active.value = items.value[index];
  }

  function handleScroll() {
    if (isMobile.value) handleScrollY(mobileY.value - 114 - 8);
    else handleScrollY(desktopY.value + 8);
  }

  watch([desktopY, mobileY, isMobile], handleScroll);

  // function scrollTo(d: Date) {
  //   const index = items.value.findIndex(i => i.getTime() === d.getTime());
  //   if (index !== -1) {
  //     const offsetTop = els.value[index].$el.offsetTop;
  //     if (isMobile.value) mobileY.value = offsetTop;
  //     else desktopY.value = offsetTop;
  //   }
  // }

  function resetScroll() {
    if (isMobile.value) mobileY.value = Math.min(mobileY.value, 156);
    else desktopY.value = 0;
  }

  return {
    // scrollTo,
    resetScroll,
    scrollContainerRef: scrollContainer,
    slotsRef: els,
  };
}
